import React from "react";
import DefaultUserHome from "src/components/feature/UserHome";

const UserHome = () => {
  return <DefaultUserHome />;
};

export default UserHome;
